import EmblaCarousel from 'embla-carousel';
import { addPrevNextLinksClickHandlers } from '../utils/embla-arrows';
import addDotLinksAndClickHandlers from '../utils/embla-dots';

const emblaNode = document.querySelector('.embla--strategy-statements');

const initStatements = () => {
  const viewportNode = emblaNode.querySelector('.embla__viewport');
  const prevBtnNode = emblaNode.querySelector('.embla__prev');
  const nextBtnNode = emblaNode.querySelector('.embla__next');
  const dotsNode = emblaNode.querySelector('.embla__dots');

  const emblaApi = EmblaCarousel(viewportNode, {
    duration: 40,
    loop: true,
  });

  const removePrevNextLinksClickHandlers = addPrevNextLinksClickHandlers(
    emblaApi,
    prevBtnNode,
    nextBtnNode,
  );
  const removeDotLinksAndClickHandlers = addDotLinksAndClickHandlers(
    emblaApi,
    dotsNode,
  );

  emblaApi.on('destroy', removePrevNextLinksClickHandlers);
  emblaApi.on('destroy', removeDotLinksAndClickHandlers);
};

(() => {
  if (emblaNode) {
    initStatements();
  }
})();
